import { NavLink as Link, Route, Routes, useLocation, useNavigate, useParams } from "react-router";
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, TabPane, UncontrolledDropdown } from "reactstrap";

import { useEffect } from "react";
import { useAnyActivePath } from "../../util/useAnyActivePath";

const RouteNavItem = ({ path, label }) => {
  return (
    <NavItem key={path}>
      <NavLink tag={Link} to={path} relative="route" end>
        {label}
      </NavLink>
    </NavItem>
  );
};

const RouteDropdownItem = ({ path, label }) => {
  return (
    <DropdownItem tag={Link} to={path}>
      {label}
    </DropdownItem>
  );
};

const RouteDropdownMenu = ({ label, items, basePath }) => {
  const hasActiveItem = useAnyActivePath(...items.map((t) => `${basePath}/${t.path}`));

  return (
    <UncontrolledDropdown nav inNavbar>
      <DropdownToggle nav caret className={hasActiveItem ? "active" : ""}>
        {label}
      </DropdownToggle>

      <DropdownMenu>
        {items.map(({ path, label }) => (
          <RouteDropdownItem key={path} path={`${basePath}/${path}`} label={label} />
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const TabbedRoute = ({ label, path, items, basePath }) => {
  if (items) {
    return <RouteDropdownMenu items={items} label={label} basePath={basePath} />;
  } else {
    return <RouteNavItem path={`${basePath}/${path}`} label={label} />;
  }
};

const useMatchNav = () => {
  const location = useLocation();
  const params = useParams();
  const wildcard = params["*"];
  const fullPath = location.pathname;

  // Remove the wildcard match and trailing `/` to get the base path
  let basePath = fullPath;
  if (wildcard && basePath.endsWith(wildcard)) {
    basePath = basePath.slice(0, -wildcard.length);
  }

  if (basePath.length > 1 && basePath.endsWith("/")) {
    basePath = basePath.slice(0, -1);
  }

  return {
    location,
    params,
    fullPath,
    basePath,
  };
};

export const TabbedRoutes = ({ tabs, defaultTab, ...rest }) => {
  const navigate = useNavigate();
  const { basePath, fullPath } = useMatchNav();

  const flattenedTabs = tabs.flatMap((tab) => (tab.items ? tab.items : [tab]));

  useEffect(() => {
    if (defaultTab && basePath == fullPath) {
      navigate(`${basePath}/${defaultTab}`, { replace: true });
    }
  }, [basePath, fullPath, defaultTab, navigate]);

  return (
    <>
      <Nav tabs className="mb-3">
        {tabs.map(({ label, path, items }) => (
          <TabbedRoute key={path || label} label={label} path={path} items={items} basePath={basePath} />
        ))}
      </Nav>

      <Routes>
        {flattenedTabs.map((t) => {
          return (
            <Route
              path={t.path}
              key={`tab-${t.path}`}
              element={
                <TabPane>
                  <t.Component {...rest} />
                </TabPane>
              }
            />
          );
        })}
      </Routes>
    </>
  );
};
